import { useState, useEffect} from "react";
import {CommonDialogBox} from "components";
import { Stack, DialogProps, Tooltip } from "@mui/material";
import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useDispatch, useSelector} from 'react-redux';
import { closeOutputUnityDialog} from 'store/main/viewObjects';
import { RootState } from 'store';
import { styled } from "@mui/material/styles";
import jwtService from 'services/jwtService';
import { getCachedData } from "api/Cache";
import NotificationMsg from "panels/CreateProcessPanel/NotificationMsg";
import NotificationModel from 'components/notificationPanel/model/NotificationModel';
import { addNotification } from 'components/notificationPanel/store/dataSlice';
import { config } from "config";


interface IType {
    name : string;
    id : string;
 }

function Unity(props:any) {

  
    const {project, catalogId, name, isFolder} = props;
    const data = getCachedData();
    //console.log("Data 1: " + JSON.stringify(data['views']))
    const dispatch = useDispatch();
    const viewObject = useSelector((state: RootState) => state.main.viewObject);
    const { oustate } = viewObject;
    const [listObjects, setListObjects] = useState<IType[]>([])
    const [fileDate, setFileDate] = useState('')
    const [coordOriginX, setCoordOriginX] = useState('')
    const [coordOriginY, setCoordOriginY] = useState('')
    const [coordOriginZ, setCoordOriginZ] = useState('')
    const [voxelSize, setVoxelSize] = useState('')

    const [horizontalDatum, setHorizontalDatum] = useState('')
    const [verticalDatum, setVerticalDatum] = useState('')
    const [projections, setProjections] = useState('')
    const [horizontalUnits, setHorizontalUnits] = useState('')
    const [verticalUnits, setVerticalUnits] = useState('')

    const CustomTextField = styled(TextField)({
        "& .MuiInputBase-root": {
            height: "40px", // Set your desired height
        },
    });

    const [itemName, setItemName] = useState('New ' + name)
    const [itemNameError, setItemNameError] = useState(false)
    const [helperItemName, setHelperItemName] = useState('')
    
    const [views, setViews] = useState('')
      
    const closeComposeDialog: DialogProps["onClose"] = (event, reason) => {
        dispatch(closeOutputUnityDialog({}))
    }

	const cancel = () => {
        dispatch(closeOutputUnityDialog({}))
	}
 
    const handleName = (e:any) => {
        setItemName(e.target.value)
        if(e.target.value === ''){
            setItemNameError(true);
            setHelperItemName("Please select a name");
        }else{
            setItemNameError(false);
            setHelperItemName("");
        }
    }

       
    const DialogAction = () => {
        return (
            <>
                <Button onClick={cancel}>Cancel</Button>
                <Button 
                    variant="contained"
                    color="primary"
                    type="submit" onClick={create}
                    sx={{
                        '&.Mui-disabled': {
                            backgroundColor: (theme) => theme.palette.background.default,
                            color: (theme) => theme.palette.text.disabled,
                            opacity: '.75'
                        },
                    }}
                >
                    Create
                </Button>
            </>
        )
    }

    const create = async () => {

        const payload = {
         
            coord_hdatum: horizontalDatum,
            coord_origin_x: coordOriginX.toString(),
            coord_origin_y: coordOriginY.toString(),
            coord_origin_z: coordOriginZ.toString(),
            coord_projection: projections,
            coord_projection_aeac_falseEasting: "0.0",
            coord_projection_aeac_falseNorthing: "0.0",
            coord_projection_aeac_latOfOriginDeg: "0.0",
            coord_projection_aeac_longOfOriginDeg: "0.0",
            coord_projection_aeac_firstStdParallelDeg: "0.0",
            coord_projection_aeac_secondStdParallelDeg: "0.0",
            coord_projection_amg_zone: "48",
            coord_projection_lcc_falseEasting: "0.0",
            coord_projection_lcc_falseNorthing: "0.0",
            coord_projection_lcc_latOfOriginDeg: "0.0",
            coord_projection_lcc_longOfOriginDeg: "0.0",
            coord_projection_lcc_firstStdParallelDeg: "0.0",
            coord_projection_lcc_secondStdParallelDeg: "0.0",
            coord_projection_tm_falseEasting: "0.0",
            coord_projection_tm_falseNorthing: "0.0",
            coord_projection_tm_latOriginDeg: "0.0",
            coord_projection_tm_longMeridianDeg: "0.0",
            coord_projection_tm_scaleFactor: "0.0",
            coord_unit: horizontalUnits,
            coord_vdatum: verticalDatum,
            file_date: fileDate,
            file_folder: isFolder ? catalogId : "0",
            file_size: "0",
            file_type: "UNITY",
            http_server: config.api.baseUrl,
            name: itemName,
            state: "PARTIAL",
            streaming_ip: config.api.baseUrl.replace(/(^\w+:|^)\/\//, '').replace(/\/$/, ''),
            streaming_port : "3333",
            streaming_ssl : "1",
            type: "FILE",
            voxel_size: voxelSize
        }
       
        const response = await jwtService.fetchRequest({
			method: 'POST',
			url: `/entity.ashx?project=${project}`,
			data: (views !== '' ? {...payload, view: views} : payload),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
		});

		const data = response.data;

        if(data.result === 'success') {
            dispatch(addNotification(NotificationModel({ message: <NotificationMsg msg={itemName}/>, options: { variant: 'success' } })));
        }else{
            dispatch(addNotification(NotificationModel({ message: 'An error occurs during the process upload', options: { variant: 'error' } })));
        }
        setTimeout(() => {
            dispatch(closeOutputUnityDialog({}))
        }, 100);
        
    }

    useEffect(() => {
       
        var allViews = data["views"];
        let allObjts : {name : string, id : string}[] = [];
        if(typeof allViews !== "undefined") {
            const keys = Object.keys(allViews);
            keys.forEach((key, index)  => {
                
                if(allViews[key]['type'] === 'FILE' && allViews[key]['project'] === catalogId){
                    allObjts.push({name: allViews[key]['name'], id : allViews[key]['ID']})
                }
            })
            setListObjects(allObjts);
        }
    }, [data, catalogId])

    useEffect(() => {
        const projects: any = data?.projects?.[project];
        if (!projects) return;

        setHorizontalDatum(projects.coord_hdatum ?? "");
        setVerticalDatum(projects.coord_vdatum ?? "");
        setProjections(projects.coord_projection ?? "");
        setHorizontalUnits(projects.coord_unit ?? "");
        setVerticalUnits(projects.coord_unit ?? "");
        setFileDate(projects.file_date ?? "");
        setCoordOriginX(projects.coord_origin_x ?? "");
        setCoordOriginY(projects.coord_origin_y ?? "");
        setCoordOriginZ(projects.coord_origin_z ?? "");
        setVoxelSize(projects.voxel_size ?? "");
        
    }, [data, project])


    return (
		<>
            <CommonDialogBox
                classes={{
                    paper: 'm-5 rounded-8'
                }}
                open={oustate}
                handleClose={closeComposeDialog}
                fullWidth
                maxWidth="sm"
                subtitle1={`${name}`}
                titleh5=''
                dialogAction={<DialogAction />}
                displayScrollBar={true}
                maxHeight={400}
            >
                <div id="progressContainer" style={{ display:'none' }}></div>
               
                <Stack 
                    gap={1}
                >
                    <Tooltip title="A descriptive, readable name for the unity" placement="top" arrow>
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="itemName"
                        name="itemName"
                        label="Name"
                        error={itemNameError}
                        helperText={helperItemName}
                        value={itemName}
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        onChange={(e) => handleName(e)}
                        style={{marginBottom: '10px'}}
                    /> 
                    </Tooltip>

                    <CustomTextField
                        required
                        margin="dense"
                        id="view"
                        name="view"
                        label="Default View"
                        type="txt"
                        select
                        fullWidth
                        value={views}
                        color='primary'
                        variant="outlined"
                        onChange={(e:any) => setViews(e.target.value)}
                    >
                        {
                            listObjects.map(elem => <MenuItem value={elem.id} key={elem.id}>{elem.name}</MenuItem>)
                        }
                    </CustomTextField> 
                </Stack>
            </CommonDialogBox>
		</>
  	)
}

export default Unity